import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, filter: string): string {
    if (filter == '') return value;

    let result = '';
    try {
      let index = 0;
      let nextIndex = 0;

      do {
        nextIndex = value.toLowerCase().indexOf(filter.toLowerCase(), index);
        if (nextIndex != -1) {
          result +=
            value.substr(index, nextIndex - index) +
            '<strong><mark>' +
            value.substr(nextIndex, filter.length) +
            '</mark></strong>';
        } else {
          result += value.substr(index);
        }

        index = nextIndex + filter.length;
      } while (nextIndex != -1);
    } catch (error) {
      result = value;
    }
    return result;
  }
}
